import { useMutation, useQueryClient } from "@tanstack/react-query";
import { removeLead } from "../../services/apiLeads";
import toast from "react-hot-toast";

export function useRemoveContractLeads() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ proposalId, searchType }) => removeLead(proposalId, searchType),
    onMutate: async ({ proposalId }) => {
      // Cancel any outgoing refetches
      // (so they don't overwrite our optimistic update)
      await queryClient.cancelQueries(["leadsContracts"]);

      // Snapshot the previous value
      const previousLeads = queryClient.getQueryData(["leadsContracts"]);

      // Optimistically update to the new value
      queryClient.setQueryData(["leadsContracts"], (oldLeads) => ({
        federal: oldLeads.federal.filter(
          (contract) => contract.NoticeId !== proposalId
        ),
        sled: oldLeads.sled.filter((contract) => contract.id !== proposalId),
        grant: oldLeads.grant.filter((contract) => String(contract.id) !== proposalId),
        sbir: oldLeads.sbir.filter((contract) => String(contract.id) !== proposalId),
      }));

      // Return a context object with the snapshotted value
      return { previousLeads };
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["leads"]);
      queryClient.invalidateQueries(["leadsContracts"]);
    },
    onError: (e, newLeads, context) => {
      queryClient.setQueryData(["leadsContracts"], context?.previousLeads);
      if (e.response?.data?.detail) toast.error(e.response?.data?.detail);
      else toast.error(e.message);
    },
    // Always refetch after error or success:
    onSettled: () => {
      queryClient.invalidateQueries(["leads"]);
      queryClient.invalidateQueries(["leadsContracts"]);
    },
  });
}
